<template>
  <div>
    <v-card style="padding: 10px">
      <v-card-title>إعدادات خدمة العملاء والطلبات</v-card-title>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field v-model="sources_string" label="تحديد المصادر (مفصولة بفاصلة)" hint="مثال: 1006,1007,1008"
              persistent-hint outlined dense />
          </v-col>

          <v-col cols="12">
            <v-divider class="my-2"></v-divider>
            <h3 class="text-subtitle-1 font-weight-bold mb-2">الإعدادات العامة</h3>
          </v-col>

          <v-col cols="12" lg="6" md="6" sm="6">
            <v-text-field v-model="askRequest_hours" label="عدد الساعات المسموحة للطلب" type="number" outlined dense
              min="0" />
          </v-col>

          <v-col cols="12" lg="6" md="6" sm="6">
            <v-text-field v-model="trans_basket_request_count" label="عدد طلبات الاستشاري لسلة التحويل" type="number" outlined dense
              min="0" />
          </v-col>

          <!-- <v-col cols="12" lg="3" md="4" sm="6">
            <v-text-field v-model="trans_basket_customer_services_request_count" label="عدد طلبات خدمة العملاء"
              type="number" outlined dense min="0" />
          </v-col> -->

          <v-col cols="12">
            <v-divider class="my-2"></v-divider>
            <h3 class="text-subtitle-1 font-weight-bold mb-2">إعدادات طلب عملاء الاستشاري</h3>
          </v-col>

          <v-col cols="12" lg="3" md="4" sm="6">
            <v-switch v-model="askRequest_active" :true-value="'true'" :false-value="'false'" inset flat
              label="تفعيل أطلب عملاء استشاري" color="primary" />
          </v-col>

          <v-col cols="12" lg="3" md="4" sm="6">
            <v-text-field v-model="askRequest_noRequest" label="عدد الطلبات المسموحة" type="number" outlined dense
              min="0" />
          </v-col>

          <v-col cols="12" lg="3" md="4" sm="6">
            <v-text-field v-model="askRequest_eachDay" label="طلبات كل يوم" type="number" outlined dense min="0" />
          </v-col>

          <v-col cols="12">
            <v-divider class="my-2"></v-divider>
            <h3 class="text-subtitle-1 font-weight-bold mb-2">إعدادات طلب عملاء خدمة العملاء</h3>
          </v-col>

          <v-col cols="12" lg="3" md="4" sm="6">
            <v-switch v-model="askRequestCustomerServices_active" :true-value="'true'" :false-value="'false'" inset flat
              label="تفعيل أطلب عملاء خدمة العملاء" color="primary" />
          </v-col>

          <v-col cols="12" lg="3" md="4" sm="6">
            <v-text-field v-model="askRequestCustomerServices_noRequest" label="عدد الطلبات المسموحة" type="number"
              outlined dense min="0" />
          </v-col>

          <v-col cols="12" lg="3" md="4" sm="6">
            <v-text-field v-model="askRequestCustomerServices_eachDay" label="طلبات كل يوم" type="number" outlined dense
              min="0" />
          </v-col>

          <v-col cols="12">
            <v-divider class="my-2"></v-divider>
            <h3 class="text-subtitle-1 font-weight-bold mb-2">إعدادات نقل الطلب المعلق</h3>
          </v-col>

          <v-col cols="12" lg="4" md="6" sm="6">
            <v-switch v-model="movePendingByAgent_active" :true-value="'true'" :false-value="'false'" inset flat
              label="تفعيل نقل الطلب المعلق" color="primary" />
          </v-col>

          <v-col cols="12" lg="4" md="6" sm="6">
            <v-text-field v-model="movePendingByAgent_noRequest" label="عدد الطلبات المسموحة للنقل يومياً" type="number"
              outlined dense min="0" />
          </v-col>
        </v-row>

        <v-row v-if="sources.length > 0">
          <v-col cols="12">
            <v-card outlined>
              <v-card-subtitle>المصادر المحددة:</v-card-subtitle>
              <v-card-text>
                <v-chip v-for="(source, index) in sources" :key="index" class="ma-1" color="primary" outlined>
                  {{ source }}
                </v-chip>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="resetForm">
          إلغاء
        </v-btn>
        <v-btn color="primary" @click="updateSettings" :loading="loading">
          حفظ الإعدادات
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Axios from "axios";
import { axiosInstance } from "@/axios/config";

export default {
  name: "CustomerServicesSettings",

  data() {
    return {
      loading: false,
      sources_string: "",
      sources: [],

      askRequest_active: 'false',
      askRequest_hours: "",
      askRequest_noRequest: "",
      askRequest_eachDay: '',

      askRequestCustomerServices_active: 'false',
      askRequestCustomerServices_noRequest: "",
      askRequestCustomerServices_eachDay: "",

      movePendingByAgent_active: 'false',
      movePendingByAgent_noRequest: "",

      trans_basket_customer_services_request_count: "",
      trans_basket_request_count: "",

      originalData: {},
    };
  },

  watch: {
    sources_string(newVal) {
      if (newVal) {
        this.sources = newVal
          .split(',')
          .map(s => s.trim())
          .filter(s => s !== '');
      } else {
        this.sources = [];
      }
    }
  },

  methods: {
    getSettings() {
      this.loading = true;

      Axios.get(
        `${this.$store.state.url}/employee/admin/customer-services/sources`,
        {
          headers: this.request_headers(),
        }
      )
        .then((res) => {
          const payload = res.data.payload;

          this.sources_string = payload.sources_string || "";
          this.sources = payload.sources || [];

          this.askRequest_active = payload.askRequest_active || 'false';
          this.askRequest_hours = payload.askRequest_hours || "";
          this.askRequest_noRequest = payload.askRequest_noRequest || "";
          this.askRequest_eachDay = payload.askRequest_eachDay || '';

          this.askRequestCustomerServices_active = payload.askRequestCustomerServices_active || 'false';
          this.askRequestCustomerServices_noRequest = payload.askRequestCustomerServices_noRequest || "";
          this.askRequestCustomerServices_eachDay = payload.askRequestCustomerServices_eachDay || '';

          this.movePendingByAgent_active = payload.movePendingByAgent_active || 'false';
          this.movePendingByAgent_noRequest = payload.movePendingByAgent_noRequest || "";

          this.trans_basket_customer_services_request_count = payload.trans_basket_customer_services_request_count || "";
          this.trans_basket_request_count = payload.trans_basket_request_count || "";

          this.originalData = { ...this.$data };

          this.loading = false;
        })
        .catch((err) => {
          this.showPopup("error", "حدث خطأ في تحميل الإعدادات");
          console.error(err);
          this.loading = false;
        });
    },

    updateSettings() {
      this.loading = true;

      const body = new FormData();

      body.append("sources", this.sources_string);

      body.append("askRequest_active", this.askRequest_active);
      body.append("askRequest_hours", this.askRequest_hours);
      body.append("askRequest_noRequest", this.askRequest_noRequest);
      body.append("askRequest_eachDay", this.askRequest_eachDay);

      body.append("askRequestCustomerServices_active", this.askRequestCustomerServices_active);
      body.append("askRequestCustomerServices_noRequest", this.askRequestCustomerServices_noRequest);
      body.append("askRequestCustomerServices_eachDay", this.askRequestCustomerServices_eachDay);

      body.append("movePendingByAgent_active", this.movePendingByAgent_active);
      body.append("movePendingByAgent_noRequest", this.movePendingByAgent_noRequest);

      body.append("trans_basket_customer_services_request_count", this.trans_basket_customer_services_request_count);
      body.append("trans_basket_request_count", this.trans_basket_request_count);

      axiosInstance
        .post(`/employee/admin/customer-services/sources`, body)
        .then((res) => {
          this.showPopup("success", res.data.message);
          this.getSettings();
        })
        .catch((err) => {
          const errorMessage = err.response?.data?.message || "حدث خطأ في حفظ الإعدادات";
          this.showPopup("error", errorMessage);
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resetForm() {
      Object.assign(this.$data, this.originalData);
    },
  },

  created() {
    this.getSettings();
  },
};
</script>

<style lang="scss" scoped>
.v-text-field {
  padding-top: 12px !important;
  margin-top: 4px;
}

label.v-label.v-label--active.theme--light.primary--text {
  left: auto;
  position: absolute;
  top: 0;
  right: -11px;
}

.v-card {
  margin: 20px 0;
}

.v-divider {
  margin: 16px 0;
}
</style>